module.exports = __webpack_public_path__ + "static/media/pin-hover.d4afa00b.png";